import { axInst } from "../Login/Service.jsx";

//region
export const fetchRegion = async () => {
  const { data } = await axInst.post(
    "dealer-sales-success-centre/sales_service_filter",
    {
      region: [],
      NEW_REGION: [],
      state: [],
      state_office: [],
      dealer_name: [],
      dealer_code: [],
      Product_Line: [],
      lob: [],
      Tsm_Name: [],
      Spm_Name: [],
    }
  );

  const regionsArray = data?.REGION.buckets.map((e) => e.key);
  const sortedRegionArray = regionsArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedRegionArray;
};

export const fetchNewRegion = async (pRegion) => {
  const { data } = await axInst.post(
    "dealer-sales-success-centre/sales_service_filter",
    {
      region: pRegion || [],
      NEW_REGION: [],
      state: [],
      state_office: [],
      dealer_name: [],
      dealer_code: [],
      Product_Line: [],
      lob: [],
      Tsm_Name: [],
      Spm_Name: [],
    }
  );

  const NewregionsArray = data?.NEW_REGION.buckets.map((e) => e.key);
  const sortedNewregionsArrayArray = NewregionsArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedNewregionsArrayArray;
};

//state
export const fetchStates = async (pRegion, pNewRegion) => {
  const { data } = await axInst.post(
    "dealer-sales-success-centre/sales_service_filter",
    {
      region: pRegion || [],
      NEW_REGION: pNewRegion || [],
      state: [],
      state_office: [],
      dealer_name: [],
      dealer_code: [],
      Product_Line: [],
      lob: [],
      Tsm_Name: [],
      Spm_Name: [],
    }
  );
  const statesArray = data?.STATE.buckets.map((e) => e.key);
  const sortedStatesArray = statesArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedStatesArray;
};

//stateoffice
export const fetchArea = async (pRegion, pNewRegion, pState) => {
  const { data } = await axInst.post(
    "dealer-sales-success-centre/sales_service_filter",
    {
      region: pRegion || [],
      NEW_REGION: pNewRegion || [],
      state: pState || [],
      state_office: [],
      dealer_name: [],
      dealer_code: [],
      Product_Line: [],
      lob: [],
      Tsm_Name: [],
      Spm_Name: [],
    }
  );
  const statesOfficeArray = data?.AREA.buckets.map((e) => e.key);
  const sortedStatesOfficeArray = statesOfficeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedStatesOfficeArray;
};

//DealerName
export const fetchDealer = async (pRegion, pNewRegion, pState, pArea) => {
  const { data } = await axInst.post(
    "dealer-sales-success-centre/sales_service_filter",
    {
      region: pRegion || [],
      NEW_REGION: pNewRegion || [],
      state: pState || [],
      state_office: pArea || [],
      dealer_name: [],
      dealer_code: [],
      Product_Line: [],
      lob: [],
      Tsm_Name: [],
      Spm_Name: [],
    }
  );
  const DealerArray = data?.DEALER_NAME.buckets.map((e) => e.key);
  const sortedDealerArray = DealerArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedDealerArray;
};

//DealerCode
export const fetchDealercode = async (
  pRegion,
  pNewRegion,
  pState,
  pArea,
  pDealer
) => {
  const { data } = await axInst.post(
    "dealer-sales-success-centre/sales_service_filter",
    {
      region: pRegion || [],
      NEW_REGION: pNewRegion || [],
      state: pState || [],
      state_office: pArea || [],
      dealer_name: pDealer || [],
      dealer_code: [],
      Product_Line: [],
      lob: [],
      Tsm_Name: [],
      Spm_Name: [],
    }
  );
  const dealercodeArray = data?.DEALER_CODE.buckets.map((e) => e.key);
  const sorteddealercodeArray = dealercodeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sorteddealercodeArray;
};

export const fetchProductLine = async (
  pRegion,
  pNewRegion,
  pState,
  pArea,
  pDealer,
  pDealerCode
) => {
  const { data } = await axInst.post(
    "dealer-sales-success-centre/sales_service_filter",
    {
      region: pRegion || [],
      NEW_REGION: pNewRegion || [],
      state: pState || [],
      state_office: pArea || [],
      dealer_name: pDealer || [],
      dealer_code: pDealerCode || [],
      Product_Line: [],
      lob: [],
      Tsm_Name: [],
      Spm_Name: [],
    }
  );
  const productLineArray = data?.Product_Line.buckets.map((e) => e.key);

  const sortedProductLineArray = productLineArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedProductLineArray;
};

//Lob
export const fetchLOB = async (
  pRegion,
  pNewRegion,
  pState,
  pArea,
  pDealer,
  pDealerCode,
  pProductLine
) => {
  const { data } = await axInst.post(
    "dealer-sales-success-centre/sales_service_filter",
    {
      region: pRegion || [],
      NEW_REGION: pNewRegion || [],
      state: pState || [],
      state_office: pArea || [],
      dealer_name: pDealer || [],
      dealer_code: pDealerCode || [],
      Product_Line: pProductLine || [],
      lob: [],
      Tsm_Name: [],
      Spm_Name: [],
    }
  );

  const lobArray = data?.LOB.buckets.map((e) => e.key);
  const sortedLobArray = lobArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedLobArray;
};

//Lob
export const fetchTsm = async (
  pRegion,
  pNewRegion,
  pState,
  pArea,
  pDealer,
  pDealerCode,
  pProductLine,
  pLob
) => {
  const { data } = await axInst.post(
    "dealer-sales-success-centre/sales_service_filter",
    {
      region: pRegion || [],
      NEW_REGION: pNewRegion || [],
      state: pState || [],
      state_office: pArea || [],
      dealer_name: pDealer || [],
      dealer_code: pDealerCode || [],
      Product_Line: pProductLine || [],
      lob: pLob || [],
      Tsm_Name: [],
      Spm_Name: [],
    }
  );

  const tsmArray = data?.TSM_NAME.buckets.map((e) => e.key);
  const sortedtsmArray = tsmArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedtsmArray;
};

export const fetchSpm = async (
  pRegion,
  pNewRegion,
  pState,
  pArea,
  pDealer,
  pDealerCode,
  pProductLine,
  pLob,
  pTsmName
) => {
  const { data } = await axInst.post(
    "dealer-sales-success-centre/sales_service_filter",
    {
      region: pRegion || [],
      NEW_REGION: pNewRegion || [],
      state: pState || [],
      state_office: pArea || [],
      dealer_name: pDealer || [],
      dealer_code: pDealerCode || [],
      Product_Line: pProductLine || [],
      lob: pLob || [],
      Tsm_Name: pTsmName || [],
      Spm_Name: [],
    }
  );

  const spmArray = data?.SPM_NAME.buckets.map((e) => e.key);
  const sortedspmArray = spmArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedspmArray;
};
